import useIsVT911CoreEnabled from '../../../../../hooks/useIsVT911CoreEnabled';
import { LiveVideoCard as CommunicatorVideoCard } from './LiveVideoCard';
import LiveVideoCardLegacy from './LiveVideoCardLegacy';

export const LiveVideoCard = () => {
  const isVT911CoreEnabled = useIsVT911CoreEnabled();

  if (isVT911CoreEnabled) {
    // If new livekit version of video to 911 is enabled use it
    return <CommunicatorVideoCard />;
  }

  return <LiveVideoCardLegacy />;
};
